import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./Settings.module.sass";
import Dropdown from "../../../components/Dropdown";
import Checkbox from "../../../components/Checkbox";
import customers from "../../../i11/Customers";
import { useUser } from "../../../context";

const objectFlip = (obj) => {
	return Object.keys(obj).reduce((ret, key) => {
		ret[obj[key]] = key;
		return ret;
	}, {});
};

const options = ["Created date", "Username", "Email address"];
const vals = {
	"Created date": "createdAt",
	Username: "userName",
	"Email address": "email",
};
const options1 = ["Ascending", "Descending"];
const vals1 = {
	Ascending: "asc",
	Descending: "desc",
};

const Settings = ({ filter, setFilter, setVisible }) => {
	const { locale } = useUser();
	const [sorting, setSorting] = useState(objectFlip(vals)[filter.sortBy]);
	const [order, setOrder] = useState(objectFlip(vals1)[filter.orderBy]);

	const [isSus, setSus] = useState(filter.isSuspended);

	useEffect(() => {
		console.log(isSus);
	}, [isSus]);

	const apply = (e) => {
		if (isSus) {
			setFilter((p) => {
				return {
					...p,
					sortBy: vals[sorting],
					orderBy: vals1[order],
					isSuspended: isSus,
				};
			});
		} else {
			const tmp = { ...filter };
			// delete tmp.isSuspended;
			setFilter({
				...tmp,
				sortBy: vals[sorting],
				orderBy: vals1[order],
			});
		}
		setVisible(false);
	};

	return (
		<div className={styles.settings}>
			<div className={styles.group}>
				<div className={styles.item}>
					<div className={styles.flex}>
						<Dropdown
							className={styles.dropdown}
							classDropdownLabel={styles.label}
							value={sorting}
							setValue={setSorting}
							options={options}
							dictionary={customers[locale].optionsDic}
							label={customers[locale].sort_by}
						/>
						<Dropdown
							className={styles.dropdown}
							classDropdownLabel={styles.label}
							value={order}
							setValue={setOrder}
							options={options1}
							dictionary={customers[locale].valsDic}
							label={customers[locale].order_by}
						/>
					</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>{customers[locale].showing}</div>
					<div className={styles.list}>
						<Checkbox
							className={styles.checkbox}
							content={customers[locale].suspended}
							value={isSus}
							onChange={() => setSus((p) => !p)}
							reverse
						/>
					</div>
				</div>
				<div className={styles.btns}>
					<button className={cn("button-stroke", styles.button)}>
						{customers[locale].reset}
					</button>
					<button className={cn("button", styles.button)} onClick={apply}>
						{customers[locale].apply}
					</button>
				</div>
			</div>
		</div>
	);
};

export default Settings;
